import { useCallback, useEffect, useState } from 'react';

export const useDebouncedAsyncCallback = <T extends (...args: Array<any>) => void>(
    callback: T
): ((...args: Parameters<T>) => void) => {
    const [debouncedArgs, setDebouncedArgs] = useState<Parameters<T> | null>(null);
    const [activeCallback, setActiveCallback] = useState<Promise<void> | null>(null);

    useEffect(() => {
        if (debouncedArgs === null) {
            return;
        }
        if (activeCallback !== null) {
            return;
        }
        const newActiveCallback = Promise.resolve(callback(...debouncedArgs));
        setDebouncedArgs(null);
        setActiveCallback(newActiveCallback);
        newActiveCallback.finally(() => {
            setActiveCallback(null);
        });
    }, [callback, debouncedArgs, activeCallback]);

    const debouncedCallback = useCallback((...args: Parameters<T>): void => {
        setDebouncedArgs(args);
    }, []);

    return debouncedCallback;
};
